import fountainLarge from "./fountain-large.png";
import fountainMedium from "./fountain-medium.png";
import fountainSmall from "./fountain-small.png";
import outdoorShowerLarge from "./outdoor-shower-large.png";
import outdoorShowerMedium from "./outdoor-shower-medium.png";
import outdoorShowerSmall from "./outdoor-shower-small.png";
import hotTubLarge from "./hot-tub-large.png";
import hotTubMedium from "./hot-tub-medium.png";
import hotTubSmall from "./hot-tub-small.png";
import poolLarge from "./pool-large.png";
import poolMedium from "./pool-medium.png";
import poolSmall from "./pool-small.png";
import staircaseLarge from "./staircase-large.png";
import staircaseMedium from "./staircase-medium.png";
import staircaseSmall from "./staircase-small.png";
import railingsLarge from "./railings-large.png";
import railingsMedium from "./railings-medium.png";
import railingsSmall from "./railings-small.png";
import drivewayGateAutomatic from "./driveway-gate-automatic.png";
import drivewayGateSliding from "./driveway-gate-sliding.png";
import drivewayGateSwing from "./driveway-gate-swing.png";
import outdoorLightingLarge from "./outdoor-lighting-large.png";
import outdoorLightingMedium from "./outdoor-lighting-medium.png";
import outdoorLightingSmall from "./outdoor-lighting-small.png";
import retainingWallLarge from "./retaining-wall-large.png";
import retainingWallMedium from "./retaining-wall-medium.png";
import retainingWallSmall from "./retaining-wall-small.png";
import tallFencingLarge from "./tall-fencing-large.png";
import tallFencingMedium from "./tall-fencing-medium.png";
import tallFencingSmall from "./tall-fencing-small.png";
import shortFencingLarge from "./short-fencing-large.png";
import shortFencingMedium from "./short-fencing-medium.png";
import shortFencingSmall from "./short-fencing-small.png";
import playStructureLarge from "./play-structure-large.png";
import playStructureMedium from "./play-structure-medium.png";
import playStructureSmall from "./play-structure-small.png";
import deckLarge from "./deck-large.png";
import deckMedium from "./deck-medium.png";
import deckSmall from "./deck-small.png";
import drivewayLarge from "./driveway-large.png";
import drivewayMedium from "./driveway-medium.png";
import drivewaySmall from "./driveway-small.png";
import pavedPatioMediumLarge from "./paved-patio-medium-large.png";
import pavedPatioSmall from "./paved-patio-small.png";
import gravelPatioMediumLarge from "./gravel-patio-medium-large.png";
import gravelPatioSmall from "./gravel-patio-small.png";
import pathwayLarge from "./pathway-large.png";
import pathwayMedium from "./pathway-medium.png";
import pathwaySmall from "./pathway-small.png";
import grillLarge from "./grill-large.png";
import grillMedium from "./grill-medium.png";
import grillSmall from "./grill-small.png";
import pergolaMediumLarge from "./pergola-medium-large.png";
import pergolaSmall from "./pergola-small.png";
import outdoorKitchenLarge from "./outdoor-kitchen-large.png";
import outdoorKitchenSmallMedium from "./outdoor-kitchen-small-medium.png";
import firepitLarge from "./firepit-large.png";
import firepitMedium from "./firepit-medium.png";
import firepitSmall from "./firepit-small.png";
import plantingDense from "./planting-dense.png";
import plantingModerate from "./planting-moderate.png";
import plantingSparse from "./planting-sparse.png";
import raisedBedsLarge from "./raised-beds-large.png";
import raisedBedsMedium from "./raised-beds-medium.png";
import raisedBedsSmall from "./raised-beds-small.png";
import lawnLarge from "./lawn-large.png";
import lawnMedium from "./lawn-medium.png";
import lawnSmall from "./lawn-small.png";
import treesSmall from "./trees-small.png";
import treesMedium from "./trees-medium.png";
import treesLarge from "./trees-large.png";
import stairsSmall from "./stairs-small.png";
import stairsMedium from "./stairs-medium.png";
import stairsLarge from "./stairs-large.png";
import yardOnboarding from "./yard-onboarding.svg";

export {
  fountainLarge,
  fountainMedium,
  fountainSmall,
  outdoorShowerLarge,
  outdoorShowerMedium,
  outdoorShowerSmall,
  hotTubLarge,
  hotTubMedium,
  hotTubSmall,
  poolLarge,
  poolMedium,
  poolSmall,
  staircaseLarge,
  staircaseMedium,
  staircaseSmall,
  railingsLarge,
  railingsMedium,
  railingsSmall,
  drivewayGateAutomatic,
  drivewayGateSliding,
  drivewayGateSwing,
  outdoorLightingLarge,
  outdoorLightingMedium,
  outdoorLightingSmall,
  retainingWallLarge,
  retainingWallMedium,
  retainingWallSmall,
  tallFencingLarge,
  tallFencingMedium,
  tallFencingSmall,
  shortFencingLarge,
  shortFencingMedium,
  shortFencingSmall,
  playStructureLarge,
  playStructureMedium,
  playStructureSmall,
  deckLarge,
  deckMedium,
  deckSmall,
  drivewayLarge,
  drivewayMedium,
  drivewaySmall,
  pavedPatioMediumLarge,
  pavedPatioSmall,
  gravelPatioMediumLarge,
  gravelPatioSmall,
  pathwayLarge,
  pathwayMedium,
  pathwaySmall,
  grillLarge,
  grillMedium,
  grillSmall,
  pergolaMediumLarge,
  pergolaSmall,
  outdoorKitchenLarge,
  outdoorKitchenSmallMedium,
  firepitLarge,
  firepitMedium,
  firepitSmall,
  plantingDense,
  plantingModerate,
  plantingSparse,
  raisedBedsLarge,
  raisedBedsMedium,
  raisedBedsSmall,
  lawnLarge,
  lawnMedium,
  lawnSmall,
  treesSmall,
  treesMedium,
  treesLarge,
  stairsSmall,
  stairsMedium,
  stairsLarge,
  yardOnboarding,
};
